export default {"src":"/_next/static/media/content_quiz_quick_quiz.655f2dc3.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};